import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocalizedNavConfig } from 'src/shared/config';

export const useLocalizedNavConfig = () => {
  const { i18n } = useTranslation('components.navbar', { useSuspense: false });

  return useMemo(() => getLocalizedNavConfig(i18n.language), [i18n.language]);
};
